import React from 'react';
import firstImage from "../assets/WorkWit.jpg";
import secondImage from "../assets/Strut-Communications-1-3.jpg";

function Services() {
  const boxWidth = "w-full";
  const boxHeight = "h-full";

  return (
    <section className='bg-[#7F7E75]'>
      <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20 bg-[#7F7E75]">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <div className="flex items-center rounded-md px-3 py-1">
            <p className="text-md uppercase mb-8">How I Can Help</p>
          </div>
          <h2 className="text-3xl font-regular md:text-5xl uppercase mb-10 font-storia">
           Choose Your Path
          </h2>
        </div>
        <ul className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 md:gap-4">
          <li className={` bg-white p-8 md:p-10 flex flex-col items-center justify-between ${boxWidth} ${boxHeight}`}>
            <div className="flex items-center justify-center">
              <img src={firstImage} alt='Consultant meeting her client on the couch with coffee mugs in their hands - Zilker Web Design' className='h-[300px] w-[400px]'/>
            </div>
            <p className="mb-3 text-2xl md:text-3xl font-semibold text-black text-center uppercase font-storia mt-6">
              Work With Me
            </p>
            <p className=" text-black text-center text-thin w-full md:w-[350px] text-lg md:text-xl mb-8 md:mb-10 font-light">
              If you're just starting out or your current site needs a refresh, then I’ve got you covered. Every project is unique and made to show off what you offer in the best way possible.
            </p>
            <a href='/webdesign'>
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">Explore Services →</button>
            </a>
          </li>
          <li className={` bg-white p-8 md:p-10 flex flex-col items-center justify-between ${boxWidth} ${boxHeight}`}>
            <div className="flex items-center justify-center mb-6 md:mb-8">
              <img src={secondImage} alt='Team of people working together' className='h-[300px] w-[390px]'/>
            </div>
            <p className="text-2xl md:text-3xl font-semibold text-black text-center mb-6 md:mb-8 uppercase font-storia">
             Do-It-Yourself Templates
            </p>
            <p className=" text-black text-center w-full md:w-[350px] text-lg md:text-xl mb-8 md:mb-10 font-light">
             Looking for something more budget-friendly and not afraid of a little DIY? Explore my templates for Showit, Flodesk, and Notion designed to elevate your online presence.
            </p>
            <a href='/'>
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">SHOP TEMPLATES →</button>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Services;